/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

/**
 * One step the "Sequence Step" filter can offer.
 *
 * ``type`` is the step's kind on the sequence's current version, so the filter
 * can show what Step 2 actually is (an email, a call, a LinkedIn message). It
 * is null for a step number only an older pinned version still holds — that
 * step has no counterpart to read a type from.
 */
export interface EnrollmentStepOption {
  /** @minimum 1 */
  number: number;
  type?: string | null;
}
